import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import {TopButtonAction, TopButtonCancel} from "../../../../componentsTopsa/buttons/TopButtons";
import PowiadomieniaService from "../PowiadomieniaService";
import {TopAlertSukces, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";

export default class WyslijMailDoKlientaPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tresc: '',
            czyWyslano: false,
            czyPoprawnieWyslano: false
        };
    }


    componentDidMount() {

    }

    onChangeTresc = e => {
        if (e.target.value.length <= 1000) {
            this.setState({
                tresc: e.target.value
            })
        } else {
            this.setState({
                tresc: this.state.tresc
            })
        }
    }

    onClickWyslij = () => {
        if (this.state.tresc.length > 0) {
            PowiadomieniaService.wyslijEmailaDoKlienta({
                "email": this.props.adresat,
                "tresc": this.state.tresc
            }).then((response) => {
                this.setState({
                    czyWyslano: true
                })
                if (response.status < 300) {
                    this.setState({
                        czyPoprawnieWyslano: true
                    })
                    setTimeout(() => {
                        this.props.onClickZamknij()
                    }, 3000)
                }
            }).catch((err) => {
                console.log(err)
            })
        }
        else {
            alert("Proszę uzupełnić treść")
        }
    }

    onClickAnuluj = () => {
        this.props.onClickZamknij();
    }

    render() {

        return (
            <div id={'EBUSModalContainerBG'}>
                <div id={'modalContainer'}>
                    <div id={'modalTextContent'} style={{minWidth: "800px"}}>
                        <div id={'WyslijMejlPopup'}>
                            <h4>Wyślij email na adres: {this.props.adresat}</h4>
                            <div style={{marginTop: "25px", color: "grey", textStyle: "italic", fontSize: "12px"}}>
                                Ilość znaków {this.state.tresc.length}/1000
                            </div>
                            <div>
                                <textarea className={'form-control'} rows={6} value={this.state.tresc} onChange={this.onChangeTresc}
                                          style={{maxWidth: "950px"}}></textarea>
                            </div>
                            <div style={{marginTop: "5px"}}>
                                <div className={'pull-right'}>
                                    <TopButtonCancel onClick={this.onClickAnuluj}/>
                                    <TopButtonAction text={'Wyslij'} iconType={'fa fa-send'} onClick={this.onClickWyslij} btnSize={'md'}/>
                                </div>
                                <div className={"clearfix"}></div>
                                {
                                    (this.state.czyWyslano) ?
                                        this.state.czyPoprawnieWyslano ?
                                            <TopAlertSukces text={"Wysłano pomyślnie email. Za 3 sekundy nastąpi zamknięcie okna"}/>
                                            :
                                            <TopAlertUwaga text={"Wystąpił błąd podczas próby wysłania emaila"}/>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/external_component/WyslijMailDoKlientaPopup.js